import { render } from "./ForBetterOutreach.vue?vue&type=template&id=8a5a7468&ts=true"
import script from "./ForBetterOutreach.vue?vue&type=script&lang=ts"
export * from "./ForBetterOutreach.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__